export default __webpack_public_path__ + "static/media/horse1.19ef800d.png";